import { COLORS } from '../../../../utils/colors';

export const useViewsStyles = () => {
  return {
    resetReport: {
      marginLeft: 'auto',
      textTransform: 'capitalize',
      textDecoration: 'underline',
      color: COLORS.RED,
      fontSize: '.75rem',
    },
    iconTray: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
    iconButton: {
      marginRight: '1rem',
      cursor: 'pointer',
      borderRadius: '.25rem',
      padding: '.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      height: '2rem',
      color: '#888',
      '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
    },
    copilotPanel: {
      padding: 0,
      margin: 0,
      overflowY: 'hidden',
      height: 'calc(100vh - 6.8rem)',
      backgroundColor: 'white',
      display: 'flex',
      justifyContent: 'center',
    },
    imagesPanel: {
      overflowY: 'scroll',
      height: 'calc(100vh - 6rem)',
      marginTop: '-1px',
      borderTop: `1px solid #ebebeb`,
      backgroundColor: 'white',
    },
    view: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    },
    vhcInfo: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: COLORS.LIGHT_GRAY,
      paddingTop: '0.7rem',
      paddingRight: 0,
      position: 'relative',
      borderLeft: `1px solid #ebebeb`,
    },
    sidebar: {
      background: '#222222',
      height: '100%',
      width: '4.5rem',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      borderRight: `0.5px solid #ebebeb`,
      position: 'relative',
      zIndex: 1,
      paddingTop: '1rem',
    },
    sidebarButton: {
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      my: '.4rem',
      width: '2rem',
      height: '2rem',
      padding: '1.5rem',
      borderRadius: '5rem',
      border: '1px solid #ebebeb',
    },
    unreadMessageIndicator: {
      height: '.75rem',
      width: '.75rem',
      borderRadius: '.375rem',
      bgcolor: COLORS.PRIMARY,
      position: 'absolute',
      top: '.3125rem',
      right: '.4375rem',
    },
  };
};
